import LinearProgress from '@mui/material/LinearProgress';

export const Loader: React.FC = () => {
  return <LinearProgress aria-label="Linear Progress" />;
};
